export enum EnumRole {
    OWNER = 'OWNER',
    PASSENGER = 'PASSENGER',
    OPERATOR = 'OPERATOR',
    ADMIN = 'ADMIN',
    DRIVER = 'DRIVER',
}

export enum EnumLeftPanelTabs {
    LOCALITIES = 'localities',
    DIRECTIONS = 'directions',
    STOPS = 'stops',
    OPTIONS = 'options',
    SETTINGS = 'settings',
    SEASONS = 'seasons',
    SECTORS = 'sectors',
    DRIVERS = 'drivers',
    ROUTES = 'routes',
    PERMISSIONS = 'permissions',
    PASSENGERS = 'passengers',
    ADMINS = 'admins',
    BLACKS = 'blacks',
    TRIPS = 'trips',
    BOOKINGS = 'bookings',
}

export enum EnumModalTypes {
    CREATE_LOCALITY = 'create-locality',
    EDIT_LOCALITY = 'edit-locality',
    CREATE_DIRECTION = 'create-direction',
    EDIT_DIRECTION = 'edit-direction',
    CREATE_STOP = 'create-stop',
    EDIT_STOP = 'edit-stop',
    CREATE_OPTION = 'create-option',
    EDIT_OPTION = 'edit-option',
    ADD_OPTION_STOP = 'add-option-stop',
    EDIT_OPTION_STOP = 'edit-option-stop',
    CREATE_SEASON = 'create-season',
    EDIT_SEASON = 'edit-season',
    CREATE_SECTOR = 'create-sector',
    EDIT_SECTOR = 'edit-sector',
    CREATE_DRIVER = 'create-driver',
    EDIT_DRIVER = 'edit-driver',
    ADD_DRIVER_SEAT = 'create-driver-seat',
    EDIT_DRIVER_SEAT = 'edit-driver-seat',
    CREATE_ROUTE = 'create-route',
    EDIT_ROUTE = 'edit-route',
    ADD_ROUTE_SCHEDULE = 'create-route_schedule',
    EDIT_ROUTE_SCHEDULE = 'edit-route-schedule',
    INVITE_USER = 'invite-user',
    CREATE_BLACK = 'create-black',
    EDIT_BLACK = 'edit-black',
    CREATE_SCHEDULE_TABLE = 'create-schedule-table',
    CREATE_BOOKING = 'create-booking',
    BOOKING_INFO_MODAL = 'booking-info-modal',
    VEHICLE_INFO_MODAL = 'vehicle-info-modal',
}

export enum EnumLangs {
    HY = 'hy',
    EN = 'en',
    RU = 'ru',
}

export enum EnumDayOfWeek {
    MONDAY = 'MONDAY',
    TUESDAY = 'TUESDAY',
    WEDNESDAY = 'WEDNESDAY',
    THURSDAY = 'THURSDAY',
    FRIDAY = 'FRIDAY',
    SATURDAY = 'SATURDAY',
    SUNDAY = 'SUNDAY',
}
